import {
  enumListAsRecordObject,
  lookupListAsRecordObject
} from '@utils/graph-utils';

import { IPolicyPersonEnumsResponse } from '.';

export function LookupToList(data: IPolicyPersonEnumsResponse) {
  const personEnums: Record<string, Record<string, string>> = {};

  personEnums['PolicyPersonTypeList'] = enumListAsRecordObject(
    data?.PolicyPersonTypeList?.enumValues
  );
  personEnums['PersonTypes'] = enumListAsRecordObject(
    data?.PersonType?.enumValues
  );

  personEnums['phoneType'] = enumListAsRecordObject(
    data?.PhoneType?.enumValues
  );
  personEnums['genders'] = enumListAsRecordObject(data?.Gender?.enumValues);
  personEnums['addressType'] = enumListAsRecordObject(
    data?.PersonAddressType?.enumValues
  );
  personEnums['zones'] = lookupListAsRecordObject(data?.core?.getZones ?? []);
  personEnums['titles'] = lookupListAsRecordObject(data?.core?.getTitles ?? []);
  personEnums['nationalities'] = lookupListAsRecordObject(
    data?.core?.getNationalities ?? [],
    false,
    'id',
    'title',
    'code',
    true
  );
  personEnums['occupationClasses'] = lookupListAsRecordObject(
    data?.core?.getOccupationClass ?? []
  );

  // Profession dropdown (occupation id -> "Description Arabic") and the map used
  // to auto-derive the read-only Occupation Class from the chosen Profession.
  const occupationList: Record<string, string> = {};
  const occupationToClass: Record<string, string> = {};
  (data?.core?.getOccupationList ?? []).forEach((occupation) => {
    if (!occupation?.id) return;
    const description = occupation.description ?? '';
    const arabic = occupation.arabic ?? '';
    occupationList[occupation.id] = [description, arabic]
      .filter(Boolean)
      .join(' ')
      .trim();

    const classId = occupation.occupationClassId ?? occupation.occupationClass?.id;
    if (classId != null) occupationToClass[occupation.id] = String(classId);
  });
  personEnums['occupationList'] = occupationList;
  personEnums['occupationToClass'] = occupationToClass;

  personEnums['countries'] = lookupListAsRecordObject(
    data?.core?.getCountries ?? []
  );

  return personEnums;
}
